export default __webpack_public_path__ + "static/media/Gauntlets of Violent Rage.2bf897dd.jpg";